import React from 'react';
//import { AppBar, UserMenu, MenuItemLink, translate } from 'react-admin';
import { AppBar  } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
//import MyUserMenu from './MyUserMenu';
import Logo from './Logo';
import Avatar from './avatar';
import {isMobile} from 'react-device-detect';

import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

var vdisplay = 'flex';

if (isMobile) {
   vdisplay = 'none'
}

const styles = {
    title: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    AppBar: {
         backgroundColor: '#009688' 
        //backgroundColor: '#5AA6ED' 
    },
    flex: { 
        display: vdisplay,
         color: 'white' 
    },

};
  
 
const EditUserButton = ({ record }) => (
    <Button 
        component={Link}
        to={{
            pathname: 'avatars/' + JSON.parse(localStorage.getItem("user")).id  ,
        }}
    >
       <Avatar  />
    </Button>
);
 
///
const ChangePwdButton = ({ record }) => (
    <Button 
        component={Link}
        to={{
            pathname: 'users/' + JSON.parse(localStorage.getItem("user")).id  ,
        }}
    >
       <div style={styles.flex} >
            {JSON.parse(localStorage.getItem("user")).name + ' | '+ JSON.parse(localStorage.getItem("user")).type}
       </div>
    </Button>
);


///
const MyAppBar = withStyles(styles)(({ classes, ...props }) => (
    <AppBar {...props} style={ styles.AppBar  } >
        <Logo /> 
         
        <span className={classes.spacer} />
        <Typography
            variant="title"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
        />
        <span className={classes.spacer} />
        <ChangePwdButton />
        <EditUserButton />
    </AppBar>
));

export default MyAppBar;
        

        ///